import React, { forwardRef } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

// Tabs Root
const Tabs = TabsPrimitive.Root;

// Tabs List - Pill container
const TabsList = forwardRef(({ className = "", ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={`auth-btn-group ${className}`}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

// Tabs Trigger - Styled buttons
const TabsTrigger = forwardRef(({ className = "", ...props }, ref) => {
  const isActive = props["data-state"] === "active";
  return (
    <TabsPrimitive.Trigger
      ref={ref}
      className={`btn ${isActive ? "active" : ""} ${className}`}
      {...props}
    />
  );
});
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

// Tabs Content
const TabsContent = forwardRef(({ className = "", ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={`mt-3 ${className}`}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

// Export all
export { Tabs, TabsList, TabsTrigger, TabsContent };
